import { TextOperation, ISlice } from '../constants'
import { createRange } from '../range'

import { rangeReducer } from './range'

const initialState: ISlice = {
  range: createRange(0, 0),
}

export function sliceReducer(state: ISlice = initialState, operation: TextOperation) {
  const range = rangeReducer(state.range, operation)
  if (range !== state.range) {
    state = { ...state, range }
  }
  if (operation.type === 'slice-data' && operation.slice === state) {
    state = { ...state, data: operation.data }
  }
  return state
}
